export const dsn = '#{SentryDsn}';
export const environment = '#{Octopus.Environment.Name}';
export const release = '#{Octopus.Release.Number}';